import Slider from '@/components/elements/BlazeSlider3-1200';
import { getStack } from '@/lib/contentstack/stack';
import { getProductByID } from '@/lib/shopify';
import Container from '@/components/layout/Container';
import ProductCard from '@/components/blocks/product_carousel/ProductCard';

export async function fetchCarouselData(_content_type_uid, uid) {
  const Stack = getStack();
  const query = Stack.ContentType(_content_type_uid)
    .Entry(uid)
    .addParam('include_dimension', 'true')
    .only(['products', 'title', 'locale', 'uid']);
  const entry = await query.toJSON().fetch();
  const document = {
    products: entry.products,
    title: entry.title,
    entry_uid: entry.uid
  };

  return document;
}

async function fetchProductData(_content_type_uid, uid) {
  const Stack = getStack();
  const query = Stack.ContentType(_content_type_uid).Entry(uid);
  return await query.toJSON().fetch();
}

async function getShopifyProduct(product_id) {
  return await getProductByID(product_id);
}

export default async function ProductCarousel({ block, position }) {
  const { uid, _content_type_uid } = block.product_carousel.reference[0];
  const { entry_uid, products, title } = await fetchCarouselData(
    _content_type_uid,
    uid
  );

  const augmentedProducts = await Promise.all(
    products.map(async (p) => {
      const { uid, _content_type_uid } = p.reference[0];
      const {
        product_id,
        title,
        url,
        settings: { collections_tag }
      } = await fetchProductData(_content_type_uid, uid);

      const { variants, productType } = await getShopifyProduct(
        `gid://shopify/Product/${product_id}`
      );

      const productTitle =
        productType === 'Mattress'
          ? title.replace(/Mattress/i, '').trim()
          : title;

      return {
        ...p,
        title: productTitle,
        url,
        collections_tag,
        variants
      };
    })
  );

  return (
    <section
      id={entry_uid + '_' + position}
      data-name="product-carousel"
      className={`py-20 pl-5 lg:px-0 lg:py-[120px]`}
    >
      <Container>
        {title && (
          <h2 className="h4 sm:h3 lg:h2 mb-10 text-center lg:mb-15">{title}</h2>
        )}
        <Slider count={products.length}>
          {augmentedProducts.map((product, index) => {
            const {
              mobile_image: p_mobile_image,
              desktop_image: p_desktop_image,
              ...rest
            } = product;
            const mobile_image = {
              uid: p_mobile_image.uid,
              url: p_mobile_image.url,
              title: p_mobile_image.title,
              dimension: p_mobile_image.dimension
            };
            const desktop_image = {
              uid: p_desktop_image.uid,
              url: p_desktop_image.url,
              title: p_desktop_image.title,
              dimension: p_desktop_image.dimension
            };
            const images = {
              desktop: desktop_image,
              mobile: mobile_image
            };
            return <ProductCard key={index} images={images} {...rest} />;
          })}
        </Slider>
      </Container>
    </section>
  );
}
